
      function initSlides() {
             if ($(window).width() <= 751) {
                 
                 
                 if (!$('.all-products > div').hasClass('slick-initialized') && $('.all-products > div .bundle-item').length > 4) {
                     
                     $('.all-products > div').slick({
                         dots: false,
                         infinite: false,
                         arrows: false,
                         slidesToShow: 4
                         
                     });
                 }
                 $('.item-container').each(function() {
                     
                     if (!$(this).hasClass('slick-initialized')) {
                         if (!$(this).hasClass('predefined') || $(this).find('.item-card').length > 1) {
                             
                             $(this).slick({
                                 dots: false,
                                 centerMode: false,
                                 variableWidth: false,
                                 infinite: false,
                                 arrows: false,
                                 slidesToShow: 1.2
                                 
                             });
                         }
                         
                     }
                 });
                 
             } else {
                 $('.fixed-atc').show();
                 if ($('.step-carousel-container').hasClass('slick-initialized')) {
                     $('.step-carousel-container').slick('unslick');
                 }
                 if ($('.all-products > div').hasClass('slick-initialized')) {
                     $('.all-products > div').slick('unslick');
                 }
                 $('.item-container').each(function() {
                     
                     if ($(this).hasClass('slick-initialized')) {
                         $(this).slick('unslick');
                     } else {}
                 });
             }
         }
     var loaded = false;
$('.js-edit-product').on('click', function() {
  var checkExist = setInterval(function() {
   if ($('#custom-subscription-forms').length) {
      loadCYO();
      clearInterval(checkExist);
   }
    
}, 100);
});




    function loadCYO() {
     if ($('#custom-subscription-forms').length > 0) {   
         var pTitle = $('#custom-subscription-forms').attr('data-product-title');
         var pHandle = $('#custom-subscription-forms').attr('data-product-handle');
         var pId = $('#custom-subscription-forms').attr('data-variant-id');
       	 var pType = $('#custom-subscription-forms').attr('data-page-type');
         var pUrl = '/pages/feed';
         var allBundlesLimit = 0;
         var preDef = false;
         var containsArray = [];



 


         $.get('/products/' + pHandle + '.json', function(prod) {
             if (prod['product']['template_suffix'].includes('predefined') || prod['product']['title'].includes('Wild Seafood Favorites Box')) {
                 preDef = true;
             }
            var script = document.createElement('script');
            script.onload = function() {
                if (loaded){
             $('.spRem').each(function(i, obj) {
             obj.remove();
         }); 
           }
       //        
               
                 //var allBundles = JSON.parse(htmlDoc.getElementById('feed-data').innerHTML.replace(/,([^,]*)$/,'\$1') + ']');
                 var allBundles = bundle_groups;
                 var metadata = allBundles.find(x=>x.variant == pId );
          
                 if (metadata && metadata["bundle_data"]["bundle_groups"]) {
                     //todo: get qty limits for everything
                     for (bundleGroup in metadata["bundle_data"]["bundle_groups"]) {
                         var subProducts = {};
                         var grpName = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["name"].replaceAll(' ', '-').replaceAll('&', 'and');
                         allBundlesLimit += metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["qty"]; 
                         $('#custom-subscription-forms').prepend('<div id="bg-' + grpName + '"></div>');
                         const itemsFromMetadata = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"];
                         const sortedItemsFromMetadata = itemsFromMetadata.sort((a,b) => (a.display_order > b.display_order) ? 1 : -1);
                         for (item in sortedItemsFromMetadata) {
                             
                             var totalLimit = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["qty"];
                             var spHandle = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["handle"];
                             
                             var spQty = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["qty"];
                             var spLocationId = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["location_id"];
                             var spInventoryId = metadata["bundle_data"]["bundle_groups"][bundleGroup]["info"]["items"][item]["inventory_id"];
                             
                             $.ajax({
                                 async: false,
                                 url: '/products/' + spHandle,
                                 dataType: "json",
                                 success: function(product) {
                                     
                                     subProducts[product["product"]["handle"]] = {
                                         "product-image": product["product"]["image"]["src"],
                                         "product-title": product["product"]["title"],
                                         "product-inventory-id": spInventoryId,
                                         "product-location-id": spLocationId,
                                         "product-sku": product["product"]["variants"][0]["sku"],
                                         "product-qty": spQty,
                                         "product-bundle-qty": totalLimit
                                     }
                                 }
                             });
                             //jQuery.getJSON('/products/' + spHandle, function(product)  );
                         }
                         
                         //
                         
                           console.log(subProducts);
                         
                         var subProductHTML = "<p class='spRem' style='margin-bottom:0;'><b style='font-size:17px;'>Your box contains:</b></p><p class='needs-more-" + grpName + "' style='display:none;'></p><div class='item-container'>";
                         var subProductCounter = 0;
        
                         for (subProduct in subProducts) {
                             var sp = subProducts[subProduct];
                             containsArray.push(sp["product-qty"] + 'x ' + sp["product-title"]);
                             subProductHTML += "<div class='item-card card-" + subProductCounter + "'>";
                             subProductHTML += "<div>"
                             subProductHTML += "<img src='" + sp["product-image"] + "' style='display:inline-block;' width='100%'>";
                             subProductHTML += "<div style='display:inline-block;width:100%;'><p style='font-size:17px;margin-bottom:0;line-height:1.2em'>" + sp["product-title"];
                             subProductHTML += "</p><a href='/products/"+ subProduct +"' target='_blank'><small>View Details</small></a></div></div><div class='qty-container' data-item-max='" + sp["product-qty"];
                             subProductHTML += "' data-location-id='" + sp["product-location-id"] + "' data-inventory-id='" + sp["product-inventory-id"];
                             subProductHTML += "' data-item-bundle-max='" + sp["product-bundle-qty"] + "' data-sku='" + sp["product-sku"];
                             subProductHTML += "' data-product-title='" + sp["product-title"] + "' data-group-name='" + grpName + "'>";
                             subProductHTML += "<span class='minus' style='cursor:pointer;position:absolute;left:5%;'>-</span>";
                             subProductHTML += "<span class='item-qty item-qty-" + grpName + "'>0</span><span class='plus' style='cursor:pointer;position:absolute;right:5%;'>+</span></div></div>";
                             subProductCounter++;
                         }
                         subProductHTML += "</div><div style='clear:both;'></div>";
                     if (!preDef) {
                         if ($('input[name="properties[_includedSKUs]"]').length == 0) {
                             $('<input type="hidden" id="iSkus" name="properties[_includedSKUs]" value="" />').insertAfter('input[name="properties[Contains]"]');
                         } else {
                             $('input[name="properties[_includedSKUs]"]')[0].id = "iSkus";
                         }
                         $('#bg-' + grpName).prepend(subProductHTML);
                       loaded = true;
                     } else {
                         $('input[name="properties[Contains]"]')[0].value = containsArray.join(', ');
                         if ($('input[name="properties[_includedSKUs]"]').length > 0) {
                             $('input[name="properties[_includedSKUs]"]').remove();
                         }
                     }
                     if (!preDef) {
                         $("button[type=submit]").first().attr('disabled', true);
                     }
                         
                         
                         //counter variable 0. remove all hidden bundles. loop through each qty container, get location and inventory id. then recreate hidden bundles
                         
                     }
                     
                     $('input[type="hidden"][name^="properties[_bundle_item"').each(function() {
                         $(this).addClass('hidden-bundle');
                         console.log($(this));
                         var bundleItemData = JSON.parse($(this).val().replace("location_id", '"location_id"').replace("inventory_id", '"inventory_id"'));
                         console.log(bundleItemData);
                         var itemQty = $('[data-location-id="' + bundleItemData["location_id"] + '"][data-inventory-id="' + bundleItemData["inventory_id"] + '"] .item-qty');
                         itemQty.html(parseInt(itemQty.html()) + 1);
                     });
                     
                     $('.item-container .btn').on('click', function() {
                         $(this).addClass('clicked');
                     });
                   
                     $('.minus').on('click', function() {
                         var itemLimit = $(this).parent().attr('data-item-max');
                         var groupName = $(this).parent().attr('data-group-name');
                         var totalLimit = $(this).parent().attr('data-item-bundle-max');
                         var currentAmount = 0;
                         
                         $(this).parent().parent().parent().find('.item-qty-' + groupName).each(function() {
                             currentAmount += parseInt($(this).html());
                             
                         });
                         
                         if (parseInt($(this).parent().find('.item-qty-' + groupName).html()) > 0) {
                             var itemQty = parseInt($(this).parent().find('.item-qty-' + groupName).html()) - 1;
                             $(this).parent().find('.item-qty-' + groupName).html(itemQty);
                             
                             $('.hidden-bundle').remove();
                             
                           	
                             var skuArray = [];
                           if ($('#iSkus').val() != ''){
                             skuArray = JSON.parse($('#iSkus').val());
                           }
                           
                             if (skuArray[$(this).parent().attr('data-sku')] > 1) {
                                 skuArray[$(this).parent().attr('data-sku')]--;
                             } else {
                                 
                                 delete skuArray[$(this).parent().attr('data-sku')];
                             }
                             
                             $('#iSkus')[0].value = JSON.stringify(skuArray);
                             
                             var newContainsArray = [];
                             console.log("newContainsArray: ");
                            // console.log(newContainsArray)
                             var contains = $('input[name="properties[Contains]"]')[0].value.split(',');
                           // console.log(contains);
                             for (val of contains) {
                                 var vals = val.split('x ');
                                 if (vals[1] == $(this).parent().attr('data-product-title')) {
                                     var currQty = parseInt(vals[0].replace(' ', ''));
                                     if (currQty > 1) {
                                         newContainsArray.push((currQty - 1) + 'x ' + vals[1]);
                                     }
                                 } else {
                                     if (vals[1]) {
                                         newContainsArray.push(vals[0].replace(' ', '') + 'x ' + vals[1]);
                                     }
                                 }
                                 
                             }
                             
                             $('input[name="properties[Contains]"]')[0].value = newContainsArray.join(', ');
                             
                             var lineItemNo = 0;
                             $("button[type=submit]").first().attr('disabled', true);
                             $(this).parent().parent().parent().parent().parent().find('.item-qty').each(function() {
                                 
                                 
                                 var updatedItemQty = parseInt($(this).parent().find('.item-qty').html());
                                 var locationId = $(this).parent().attr('data-location-id');
                                 var inventoryId = $(this).parent().attr('data-inventory-id');
                                 var productTitle = $(this).parent().attr('data-product-title');
                                 
                                 $('.needs-more-' + groupName).html('');
                                 // console.log(totalLimit, currentAmount);
                                 $('.needs-more-' + groupName).show().html('Please add <b style="color:red;">' + (parseInt(totalLimit) - (currentAmount - 1)) + '</b> more to complete your <b> ' + pTitle + '</b>.');
                                 for (var i = 0; i < updatedItemQty; i++) {
                                     var lineItemHTML = 
                                    "<input type='hidden' name='properties[_bundle_item_" + lineItemNo + "]' value='{location_id:";lineItemHTML += locationId + ",inventory_id:" + inventoryId + "}' class='hidden-bundle'/>";
                                     lineItemNo++;
                                     $(lineItemHTML).insertAfter('input[name="properties[Contains]"]');
                                 }
                                 
                             });
                         }
                         
                     });
           
                     $('.plus').on('click', function() {
                         var itemLimit = parseInt($(this).parent().attr('data-item-max'));
                         var groupName = $(this).parent().attr('data-group-name');
                         var totalLimit = parseInt($(this).parent().attr('data-item-bundle-max'));
                         var currentAmount = 0;
                         var currentAmount2 = parseInt($(this).parent().find('.item-qty-' + groupName).html());
                         $(this).parent().parent().parent().find('.item-qty-' + groupName).each(function() {
                             currentAmount += parseInt($(this).html());
                             
                         });
                         //if item qty goes above total limit OR if item qty goes above subitem qty don't increment
                         if (currentAmount2 < itemLimit && currentAmount2 < totalLimit && currentAmount < totalLimit) {
                             var itemQty = parseInt($(this).parent().find('.item-qty-' + groupName).html()) + 1;
                             $(this).parent().find('.item-qty-' + groupName).html(itemQty);
                             
                             $('.hidden-bundle').remove();
                             
                             var lineItemNo = 0;
                             var skuArray = {};
                             
                             if ($('#iSkus')[0].value != '') {
                               
                                 skuArray = JSON.parse($('#iSkus').val());
                             }
                             if (skuArray[$(this).parent().attr('data-sku')]) {
                                 skuArray[$(this).parent().attr('data-sku')]++;
                             } else {
                                 skuArray[$(this).parent().attr('data-sku')] = 1;
                             }
                             $('#iSkus')[0].value = JSON.stringify(skuArray);
                             
                             var newContainsArray = [];
                             var contains = $('input[name="properties[Contains]"]')[0].value.split(',');
                             var updated = false;
                             for (val of contains) {
                                 var vals = val.split('x ');
                                 if (vals[1] == $(this).parent().attr('data-product-title')) {
                                     newContainsArray.push((parseInt(vals[0].replace(' ', '')) + 1) + 'x ' + vals[1]);
                                     updated = true;
                                 } else {
                                     if (vals[1]) {
                                         newContainsArray.push(vals[0].replace(' ', '') + 'x ' + vals[1]);
                                     }
                                 }
                                 
                             }
                             if (!updated) {
                                 if ($('input[name="properties[Contains]"]')[0].value != '') {
                                     $('input[name="properties[Contains]"]')[0].value = $('input[name="properties[Contains]"]')[0].value + ', 1x ' + $(this).parent().attr('data-product-title');
                                 } else {
                                     $('input[name="properties[Contains]"]')[0].value = $('input[name="properties[Contains]"]')[0].value + '1x ' + $(this).parent().attr('data-product-title');
                                 }
                             } else {
                                 $('input[name="properties[Contains]"]')[0].value = newContainsArray.join(', ');
                             }
                             $('.item-qty').each(function() {
                                 
                                 var updatedItemQty = parseInt($(this).parent().find('.item-qty').html());
                                 console.log(updatedItemQty);
                                 var locationId = $(this).parent().attr('data-location-id');
                                 var inventoryId = $(this).parent().attr('data-inventory-id');
                                 var productTitle = $(this).parent().attr('data-product-title');
                                 
                                 $('.needs-more-' + groupName).html('');
                                 $("button[type=submit]").first().attr('disabled', false);
                                 // console.log(totalLimit, currentAmount);
                                 if (currentAmount + 1 < parseInt(totalLimit)) {
                                     $("button[type=submit]").first().attr('disabled', true);
                                     $('.needs-more-' + groupName).show().html('Please add <b style="color:red;">' + (parseInt(totalLimit) - (currentAmount + 1)) + '</b> more to complete your <b> ' + pTitle + '</b>.');
                                     
                                 }
                                 for (var i = 0; i < updatedItemQty; i++) {
                                    console.log(updatedItemQty);
                                    var lineItemHTML = "<input type='hidden' name='properties[_bundle_item_" + lineItemNo + "]' value='{location_id:";lineItemHTML += locationId + ",inventory_id:" + inventoryId + "}' class='hidden-bundle'/>";
                                     lineItemNo++;
                                     $(lineItemHTML).insertAfter('input[name="properties[Contains]"');
                                     
                                 }
                                 
                                 
                             });
                           if ($('.hidden-bundle').length < allBundlesLimit) {
                                    $("button[type=submit]").first().attr('disabled', true);
                                 }
                         } else {
                             $('.needs-more-' + groupName).show().html('<span style="color:red;">You have reached the max amount of items in your box. Please remove an item before adding a new one.</span>');
                             
                         }
                         
                     });
                     
                     initSlides();
                     
                     
                     //get
                     //console.log(subProducts);
                     //console.log(metadata["bundle_data"]["bundle_groups"][0]["info"]["items"]);
                     
                 }
             };//end of 2nd function
             
            script.src = "//www.sizzlefish.com/cdn/shop/t/423/assets/bundle_settings.js?v=54993548332312474141661514397";
            document.body.appendChild(script);
         });//end of first get function
     }
    }
    loadCYO(); 
    $('#sub-btn').click(function() { 
    $('#sub-btn').html('processing...');
    $('#sub-btn').prop("disabled",true);
     var nVal = $("#iSkus")[0].value.replaceAll('"','');
     $("#iSkus").val(nVal)
      $('#sub-btn-hdn').click();
    
    });
    $('.rc_option__selector').on('change', function () {
    $('#custom-subscription-forms').empty();
    $('#iSkus').val('');
    $('.hidden-bundle').remove();
    $('input[name="properties[Contains]"').val('');
    var varId = $('#shopify_variant_id').val();
    $('#custom-subscription-forms').attr('data-variant-id', varId);
    loadCYO();
    });
    
    $('#product_options_container').find('select').first().on('change', function() {
    var val = this.value;
     $('#custom-subscription-forms').empty();
    $('#iSkus').val('');
    $('.hidden-bundle').remove();
    $('input[name="properties[Contains]"').val('');
    $('#shopify_variant_id option').each(function(){
     if(this.innerHTML.includes(val))   {
       var varId = this.value;
    $('#custom-subscription-forms').attr('data-variant-id', varId);
    loadCYO();
     }
    });
    });

    
